import React, { useEffect, useState } from "react";
import Chatheader from "../chatheader/chatheader";
import { useStateValue } from '../../../../stateprovider';
import "./extendchat.css";


const ExtendChatComp = () => {

    const [{ }, dispatch] = useStateValue();

    useEffect(() => {
        dispatch({
            type: "APP_NAV_STATE",
            appnav: true
        });
    }, []);

    return <div className="app_complaint app_extend">
        <Chatheader />
        <div className="app_extendchat_container">
            <p className="app_extendchat_container__para">
                15 minute chat with a doctor has ended <br />
                would you like to continue with the session?
            </p>
            <div className="app_extendchat_con_plan">
                <svg xmlns="http://www.w3.org/2000/svg" width="291" height="75" viewBox="0 0 291 75" fill="none">
                    <path d="M1 13.3929C1 6.56276 6.62598 1 13.5981 1H277.402C284.374 1 290 6.56275 290 13.3929V38.3929C290 45.223 284.374 50.7857 277.402 50.7857H253.579C249.161 50.7857 245.579 54.3674 245.579 58.7857V61.6071C245.579 68.4372 239.953 74 232.981 74H58.0187C51.0465 74 45.4206 68.4372 45.4206 61.6071V58.7857C45.4206 54.3674 41.8388 50.7857 37.4206 50.7857H13.5981C6.62598 50.7857 1 45.223 1 38.3929V13.3929Z" stroke="#0F0F0F" stroke-width="2" />
                    <text x="50%" y="50%" text-anchor="middle" alignment-baseline="middle" font-size="12" fill="black" class="svg_text">
                        <tspan x="50%" dy="0">Buy an <tspan className="svg_bottom_italics">Extra-time</tspan> plan for</tspan>
                        <tspan x="50%" dy="1.2em" className="svg_text_bottom">₦250</tspan>
                    </text>
                </svg>
            </div>
            <div className="app_extendchat_con_button">
                <button>Continue</button>
                <button>Cancel</button>
            </div>
            <div className="app_extendchat_con_separator">
                <div  className="app_extend_div_border"></div>
                <p>or</p>
                <div  className="app_extend_div_border"></div>

            </div>

            <div className="app_extendchat_con_footer">
                    <p>View doctors prescription</p>
                    <button>summary note</button>
            </div>
        </div>

    </div>
}
export default ExtendChatComp;